import { __rest } from './../../external/tslib/tslib.es6.js';
import React from 'react';
import { Wrapper, WrapperToggle, Input, ToggleControl } from './styles.js';
import '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import ParagraphLg from '../Text/ParagraphLg/ParagraphLg.js';
import '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';

const Toggle = (_a) => {
    var { error, variation = 'success', disabled, readOnly, label, checked, id, hideBorder, onChange, margin, marginTop, marginBottom, marginRight, marginLeft, marginHorizontal, marginVertical, m, mt, mr, mb, ml, mx, my } = _a, props = __rest(_a, ["error", "variation", "disabled", "readOnly", "label", "checked", "id", "hideBorder", "onChange", "margin", "marginTop", "marginBottom", "marginRight", "marginLeft", "marginHorizontal", "marginVertical", "m", "mt", "mr", "mb", "ml", "mx", "my"]);
    const parsedVariation = error ? 'danger' : variation;
    return (React.createElement(Wrapper, Object.assign({ label: label, disabled: disabled, readOnly: readOnly, hideBorder: hideBorder }, {
        margin,
        marginTop,
        marginBottom,
        marginRight,
        marginLeft,
        marginHorizontal,
        marginVertical,
        m,
        mt,
        mr,
        mb,
        ml,
        mx,
        my,
    }),
        label && (React.createElement(ParagraphLg, { as: "label", htmlFor: id }, label)),
        React.createElement(WrapperToggle, null,
            React.createElement(Input, Object.assign({}, props, { type: "checkbox", id: id, checked: checked, variation: parsedVariation, disabled: disabled || readOnly, readOnly: readOnly, onChange: onChange })),
            React.createElement(ToggleControl, null))));
};

export { Toggle as default };
